import React, { useContext, useState } from 'react';
import { IModifiersContext, ModifiersContext } from '../../../../../modifiersState/modifiersContext';
import { RequestEntity, IItemModifier } from 'types';
import PricesList from 'components/Lists/ListView/PricesList';
import RestaurantsList from 'components/Lists/ListView/RestaurantsList';
import Text from 'components/Text/Text';
import ImgUploaderByEntityId from 'components/ImgUploader/ImgUploaderByEntityId';
import DataController from 'components/DataController/DataController';
import Info from './components/Info/Info';
import classNames from 'classnames';
import style from './Item.module.scss';

interface IProps {
	data: IItemModifier;
	index: number;
}

const Item: React.FC<IProps> = ({ data, index }) => {
	const { setIDForDeletion, IDSelectedRestaurant } = useContext<IModifiersContext>(ModifiersContext);
	const [isOpenInfo, setIsOpenInfo] = useState<boolean>(false);

	const containerClasses = classNames(style.container, { [style.openInfo]: isOpenInfo });
	const modifierRowClasses = classNames(style.modifier, style.row);
	const nameClasses = classNames(style.name);
	const articleRowClasses = classNames(style.article, style.row);
	const restaurantRowClasses = classNames(style.restaurant, style.row, style.list);
	const customerRowClasses = classNames(style.customer, style.row);
	const isDisabledRowClasses = classNames(style.isDisabled, style.row, style.list);
	const isRestrictedRowClasses = classNames(style.isRestricted, style.row, style.list);
	const isPreselectedRowClasses = classNames(style.isPreselected, style.row, style.list);
	const priceRowClasses = classNames(style.price, style.row, style.list);
	const actionRowClasses = classNames(style.action, style.row);

	const restaurants = data.restaurantsModifiers.map((el) => ({
		...el,
		id: el.restaurantId,
	}));
	const isDisabledInRestaurants = restaurants.filter((el) => el.isDisabled);
	const isRestrictedInRestaurants = restaurants.filter((el) => el.isRestricted);
	const isPreselectedInRestaurants = restaurants.filter((el) => el.isPreselected);
	const selectedRestaurant = restaurants.find((el) => el.restaurantId === IDSelectedRestaurant);

	return (
		<div data-test={`Item-${index}`}>
			<div className={containerClasses}>
				<div className={modifierRowClasses}>
					<div className={style.imgWrapper}>
						<ImgUploaderByEntityId
							resource={RequestEntity.Modifiers}
							entityID={data.filePath ? data.id : ''}
							photoSize="Small"
							loaderSize="small"
							filePath={data.filePath}
						/>
					</div>
					<Text className={nameClasses} translationKey={data.name} withTooltip={true} />
				</div>
				<Text className={articleRowClasses} translationKey={data.articleNumber} withTooltip={true} />
				<div className={restaurantRowClasses}>
					<RestaurantsList restaurants={restaurants} />
				</div>
				<Text className={customerRowClasses} translationKey={data.customer.name} withTooltip={true} />
				<div className={isDisabledRowClasses}>
					<RestaurantsList restaurants={isDisabledInRestaurants} />
				</div>
				<div className={isRestrictedRowClasses}>
					<RestaurantsList restaurants={isRestrictedInRestaurants} />
				</div>
				<div className={isPreselectedRowClasses}>
					<RestaurantsList restaurants={isPreselectedInRestaurants} />
				</div>
				<div className={priceRowClasses}>
					<PricesList restaurants={restaurants} selectedRestaurant={selectedRestaurant} />
				</div>
				<div className={actionRowClasses}>
					<DataController
						onClickInfo={() => setIsOpenInfo(!isOpenInfo)}
						onClickDelete={() => setIDForDeletion(data.id)}
						URLWithIDToEdit={`/menu/modifiers/edit?modifierID=${data.id}`}
						size="smallBtn"
						isOpenInfo={isOpenInfo}
					/>
				</div>
			</div>
			<Info isOpenInfo={isOpenInfo} data={data} />
		</div>
	);
};

export default Item;
